import {ref} from 'vue';
import {defineStore} from 'pinia';

import {getAppContext} from '@/core/plugins/appContext';

export const useEventsStore = defineStore('events', () => {
    const {$api} = getAppContext();

    const eventsItem = ref(null);
    const latestEvents = ref(null);
    const eventsList = ref(null);

    async function getEventsList(params = {}) {
        try {
            const {data} = await $api.massmedia.events.list(params);
            eventsList.value = data;

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async function getEventsLatest() {
        try {
            const {data} = await $api.massmedia.events.latest();
            latestEvents.value = data;

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async function getEventsItem(slug) {
        try {
            const {data} = await $api.massmedia.events.details(slug);
            eventsItem.value = data;

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    return {
        eventsItem,
        latestEvents,
        eventsList,
        getEventsList,
        getEventsLatest,
        getEventsItem,
    };
});
